module.exports = __webpack_public_path__ + "static/media/vidanta.6bacebe8.mp4";